import { render, staticRenderFns } from "./ListsEditor.vue?vue&type=template&id=0ea37840&"
import script from "./ListsEditor.vue?vue&type=script&lang=js&"
export * from "./ListsEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports